import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalAngularModule } from '@cvx/cal-angular';
import { NextPage } from '@cvx/nextpage';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from '../app-routing.module';
import { AppComponent } from '../app.component';
import { TokenInterceptor } from '../core/interceptors/token.interceptor';
import { CommonFeatureModule } from '../features/common/common.module';
import { UserManagerModule } from '../features/user-manager/user-manager.module';
import { InvalidPermissionsComponent } from '../invalid-permissions/invalid-permissions.component';
import { AppConfig } from '../services/app-config.service';
import { KendoModule } from './kendo.modules';
import { AcdModule } from '../features/acd/module/acd.module';
import { ReportingDashboardModule } from '../features/reportingdashboard/module/reporting-dashboard.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DataConsoleModule } from '../features/dataconsole/dataconsole.module';
import { DashobardHomeModule } from '../features/dashboardhome/home.module';
import { CalService } from '../auth/cal.service';

export function initializeApp(appConfig: AppConfig, calService: CalService) {
  return async (): Promise<any> => {
    let appSettings = appConfig.load();
    await calService.signIn();
    return appSettings;
  }
}

@NgModule({ declarations: [
        AppComponent,
        InvalidPermissionsComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        NextPage,
        CalAngularModule.forRoot(environment.calSettings),
        BrowserAnimationsModule,
        DashobardHomeModule,
        UserManagerModule,
        DataConsoleModule,
        KendoModule,
        CommonFeatureModule,
        AcdModule,
        ReportingDashboardModule,
        NgxDaterangepickerMd.forRoot()], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppConfig, CalService],
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
